import Component from 'vue-class-component'

Component.registerHooks([
  'metaInfo'
])
